<div class="header-container">
  <app-header-v2-navigation
    [buttons]="navigationButtons()"
    [centered]="centerNavigation()"
  ></app-header-v2-navigation>

  @if (showUserActions()) {
  <div class="user-actions">
    @if (displayUser(); as user) {
      <div class="user-menu-wrap">
        <button
          type="button"
          class="user-menu-trigger"
          [class.user-menu-trigger--open]="showUserMenu()"
          [attr.aria-expanded]="showUserMenu()"
          [attr.aria-haspopup]="true"
          [attr.aria-label]="'app.header.profile' | translate"
          (click)="toggleUserMenu($event)"
        >
          <app-header-v2-avatar [user]="user"></app-header-v2-avatar>
          @if (displayName()) {
            <span class="user-menu-trigger__name">{{ displayName() }}</span>
          }
        </button>

        @if (showUserMenu()) {
          <div
            class="header-user-menu"
            role="menu"
            (click)="$event.stopPropagation()"
          >
            <div class="header-user-menu__identity">
              <p class="header-user-menu__name">{{ displayName() }}</p>
              @if (displayEmail()) {
                <p class="header-user-menu__meta">{{ displayEmail() }}</p>
              }
            </div>

            <div class="header-user-menu__actions">
              @if (showProfileAction()) {
                <button
                  type="button"
                  class="header-user-menu__action"
                  role="menuitem"
                  (click)="goToProfile()"
                >
                  <svg class="header-user-menu__action-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  <span>{{ 'app.header.profile' | translate }}</span>
                </button>
              }

              <button
                type="button"
                class="header-user-menu__action header-user-menu__action--logout"
                role="menuitem"
                (click)="logout()"
              >
                <img
                  class="header-user-menu__action-icon header-user-menu__action-icon--img"
                  src="/public/svgs/logout.svg"
                  alt=""
                  width="16"
                  height="16"
                  aria-hidden="true"
                />
                <span>{{ 'app.header.logout' | translate }}</span>
              </button>
            </div>
          </div>
        }
      </div>
    } @else {
      <app-header-v2-avatar></app-header-v2-avatar>
    }

    <button class="notification-button" type="button" aria-label="Notifications">
      <div class="nav-icon-wrapper">
        <img *ngIf="layout() === 'admin'" class="nav-icon-image" src="/public/logos/logo_v.svg" alt="Notification icon" />
        <img *ngIf="layout() === 'patrol'" class="nav-icon-image" src="/public/logos/logo_v.svg" alt="Valvur Patrol" />
        <img *ngIf="layout() === 'school'" class="nav-icon-image" src="/public/svgs/valvur-w.svg" alt="Notification icon" />
      </div>
    </button>
  </div>
  }
</div>
